import {
  HttpFeature,
  HttpFeatureKind,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '@app/shared/auth/interceptor';

export const httpClientConfig: HttpFeature<HttpFeatureKind>[] = [
  withInterceptors([authInterceptor]),
];
